/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({
    "data": {
      "categories": {
        "cardinal": ["zero", "one", "other"],
        "ordinal": ["other"]
      },
      "fn": function fn(n, ord) {
        var s = String(n).split('.'),
          i = s[0];
        if (ord) return 'other';
        return n == 0 ? 'zero' : (i == 0 || i == 1) && n != 0 ? 'one' : 'other';
      }
    },
    "locale": "lag"
  });
}